module.exports = "/img/user-guided-tours/customers-list/columns.png?7a1d16b80df35e680c5b3a643dad58f8";